import { FC } from 'react';
import styled from 'styled-components';
import { nameof } from '../../utils/stringUtils';
import { IconProps } from './LayeredIcons';
import { FlexDiv } from '../../shared/styled-components';
import { ExtrasButton } from './ExtrasButton';
import { CardHeader, Title } from './StyledComponents';

const Container = styled.div`
  flex-grow: 1;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Content = styled(FlexDiv)`
  flex-grow: 1;
`;

const Label = styled.div`
  text-align: center;
  color: ${p => p.theme.palette.neutralSecondary};
`;

interface IProps {
    title?: string;
    content: string | JSX.Element;
    label?: string | JSX.Element;
    onExtrasButtonClick?(): void;
    extrasButtonIcon?: string | IconProps[];
    extrasButtonTooltip?: string;
}

export type ICardItemProps = IProps;

const KpiDisplay: FC<IProps> = ({ title, content, label, onExtrasButtonClick, extrasButtonIcon, extrasButtonTooltip }) => (
    <Container className="display-item">
        {
            title &&
            <CardHeader>
                <Title aria-label={title}>{title}</Title>
                {
                    onExtrasButtonClick &&
                    <ExtrasButton onClick={onExtrasButtonClick} icon={extrasButtonIcon} tooltip={extrasButtonTooltip} />
                }
            </CardHeader>
        }
        <Content>{content}</Content>
        {label && <Label aria-label={typeof label === 'string' ? label : undefined}>{label}</Label>}
    </Container>
);

KpiDisplay.displayName = nameof({ KpiDisplay });
export default KpiDisplay;